var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "", role: "region", "aria-label": "Shop content" } },
    [
      _c(
        "v-parallax",
        {
          attrs: {
            src: "https://gm.goz.fun/wp-content/uploads/2023/03/shoplayout-cover.png",
            height: "350",
            "aria-label": "Shop banner",
            role: "img",
          },
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "text-center",
              attrs: { column: "", "align-center": "", "justify-center": "" },
            },
            [
              _c("h1", { staticClass: "white--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.shop.title")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "white--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.shop.subtitle")) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          attrs: {
            color: "secondary",
            role: "region",
            "aria-label": "Shop Interface",
          },
        },
        [
          _c(
            "v-layout",
            { staticClass: "primary", attrs: { column: "", "pb-2": "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md8: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "profile-section-card--flex-toolbar",
                      attrs: {
                        flat: "",
                        role: "group",
                        "aria-label": "Shop sections",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-md": "" } },
                            [
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    "fixed-tabs": "",
                                    color: "accent",
                                    "show-arrows": "",
                                    centered: "",
                                    "next-icon": "fad fa-chevron-right",
                                    "prev-icon": "fad fa-chevron-left",
                                    "slider-color": "accent",
                                    role: "tablist",
                                    "aria-label": "Shop category tabs",
                                  },
                                  model: {
                                    value: _vm.active_tab,
                                    callback: function ($$v) {
                                      _vm.active_tab = $$v
                                    },
                                    expression: "active_tab",
                                  },
                                },
                                [
                                  _c("v-tabs-slider"),
                                  _vm._v(" "),
                                  _vm._l(_vm.tabs, function (tab) {
                                    return _c(
                                      "v-tab",
                                      {
                                        key: tab.id,
                                        attrs: {
                                          to: tab.route,
                                          exact: "",
                                          role: "tab",
                                          "aria-selected":
                                            _vm.$route.path === tab.route,
                                          "aria-label":
                                            _vm.$t(
                                              "shop.tabs." + tab.category
                                            ) || tab.category,
                                          tabindex:
                                            _vm.$route.path === tab.route
                                              ? 0
                                              : -1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setCategory(tab.category)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            attrs: { "aria-hidden": true },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(tab.icon) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "shop.tabs." + tab.category
                                                ) || tab.category
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.isCompletedOAuth
                                ? _c("select-user-char", {
                                    on: { selectedChar: _vm.selectedChar },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("router-view", {
                                attrs: {
                                  "char-id": _vm.charId,
                                  category: _vm.category,
                                  role: "region",
                                  "aria-live": "polite",
                                  "aria-label": "Shop item section",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }